import { AuxiliumComponent } from "../auxilium-component";

export default class MenuDivider extends AuxiliumComponent {
	parsedCallback() {
		this.appendChild(document.createElement("hr"));
	}
}
